<template>
  <div id="app">
    <a-spin size="large" style="width: 100%" :spinning="spinning">
      <a-menu
        v-model="visible_app"
        :defaultSelectedKeys="[1]"
        mode="horizontal"
        @select="(e) => changeTab(e.key)"
      >
        <a-menu-item v-if="status_license_main.condition != 'empty'" key="1">
          <a-icon type="home" />{{ $t("Dane systemowe") }}
        </a-menu-item>
        <a-menu-item
          v-if="
            status_license_main.condition != 'empty' &&
            info.length &&
            currentUserObj &&
            (isAdmin ||
              userAccess.length ||
              currentUserObj.ID == info[currentUserIdForEdit].ID)
          "
          key="2"
        >
          <a-icon type="idcard" />{{ $t("Dane zamkniete") }}
        </a-menu-item>
        <a-menu-item v-if="status_license_main.condition != 'empty'" key="3">
          <a-icon type="schedule" />{{ $t("Urlopy") }}
        </a-menu-item>
        <a-menu-item
          v-if="
            (status_license_main.condition != 'empty' && isAdmin) ||
            userAccess.indexOf('CEO') != -1 ||
            userAccess.indexOf('HR') != -1
          "
          key="4"
        >
          <a-icon type="history" />{{ $t("Historia") }}
        </a-menu-item>
        <a-menu-item
          v-if="
            (status_license_main.condition != 'empty' && isAdmin) ||
            userAccess.indexOf('CEO') != -1 ||
            userAccess.indexOf('HR') != -1
          "
          key="5"
        >
          <a-icon type="project" />{{ $t("Raporty") }}
        </a-menu-item>
        <a-menu-item v-if="isAdmin" key="6">
          <a-icon type="setting" />{{ $t("Settings") }}
        </a-menu-item>
        <a-menu-item :key="visible_app[0]" style="border-bottom: none">
          <a-tooltip>
            <template slot="title">
              {{ $t("Have an idea to make the app better") }}
            </template>
            <a
              target="_blank"
              href="https://bitrix24public.com/cloud.bitrix24.pl/form/85_bank_idey/rqpzor/"
            >
              <img src="./assets/light.png" style="width: 24px" />
            </a>
          </a-tooltip>
        </a-menu-item>
      </a-menu>
      <div id="blockApp" class="mainpage">
        <commonData
          v-if="visible_app[0] == 1"
          :userInfo="info"
          :departments="departments"
          :currentUserIdForEdit="currentUserIdForEdit"
          @changecurrentUserIdForEdit="changecurrentUserIdForEdit"
          @loadSelectedCommonData="loadSelectedCommonData"
          :entityUser="entityUser"
          :companies="companies"
          :allcompanies="allcompanies"
          @setNewUserBxInfo="setNewUserBxInfo"
          @setNewUserInfo="setNewUserInfo"
          @resize="resize"
          :UzywaneDni="UzywaneDni"
          :DniWRoku="DniWRoku"
          :DniNieobecnosci="DniNieobecnosci"
          :currentUserObj="currentUserObj"
          :isAdmin="isAdmin"
          :userAccess="userAccess"
          :daysLeft="daysLeft"
          :currentBxUserDepartments="currentBxUserDepartments"
          :infoo_currentUsersInDepartments="infoo_currentUsersInDepartments"
        />
        <closedData
          v-else-if="visible_app[0] == 2"
          :userInfo="info"
          :currentUserIdForEdit="currentUserIdForEdit"
          @changecurrentUserIdForEdit="changecurrentUserIdForEdit"
          @loadSelectedClosedData="loadSelectedClosedData"
          :companies="companies"
          :allcompanies="allcompanies"
          :closedUserData="closedUserData"
          :adtlEmplInfDataSource="adtlEmplInfDataSource"
          @setNewClosedData="setNewClosedData"
          ref="closedData"
          @resize="resize"
          :isAdmin="isAdmin"
          :currentUserObj="currentUserObj"
          :userAccess="userAccess"
          :daysLeft="daysLeft"
          :UzywaneDni="UzywaneDni"
          :DniWRoku="DniWRoku"
          :DniNieobecnosci="DniNieobecnosci"
          :currentBxUserDepartments="currentBxUserDepartments"
          :infoo_currentUsersInDepartments="infoo_currentUsersInDepartments"
        />

        <vacationData
          v-else-if="visible_app[0] == 3"
          :userInfo="info"
          :departments="departments"
          :currentUserIdForEdit="currentUserIdForEdit"
          @changecurrentUserIdForEdit="changecurrentUserIdForEdit"
          @loadSelectedHolideyData="loadSelectedHolideyData"
          :allHolidayDay="allHolidayDays"
          @setAllHolidayDay="setAllHolidayDay"
          @setEventID="setEventID"
          :holidaysAllMass="holidaysAllMass"
          :eventID="eventID"
          @deleteIndexEvent="deleteIndexEvent"
          @loadHolidaysData="loadHolidaysData"
          @changeEventHoliday="changeEventHoliday"
          :UzywaneDni="UzywaneDni"
          :DniWRoku="DniWRoku"
          :settingsUserData="settingsUserData"
          :DniNieobecnosci="DniNieobecnosci"
          :EwentualniePozostalo="EwentualniePozostalo"
          :DataAktualizacji="DataAktualizacji"
          @resize="resize"
          :isAdmin="isAdmin"
          :currentUserObj="currentUserObj"
          :userAccess="userAccess"
          @onChangeHolidayMode="onChangeHolidayMode"
          :localeApp="localeApp"
          :currentBxUserDepartments="currentBxUserDepartments"
          :infoo_currentUsersInDepartments="infoo_currentUsersInDepartments"
        />
        <additionalData
          v-else-if="visible_app[0] == 4"
          :userInfo="info"
          :departments="departments"
          :currentUserIdForEdit="currentUserIdForEdit"
          @changecurrentUserIdForEdit="changecurrentUserIdForEdit"
          @loadSelectedAdditionalData="loadSelectedAdditionalData"
          :isAdmin="isAdmin"
          @resize="resize"
          :companies="companies"
          :currentUserObj="currentUserObj"
          :userAccess="userAccess"
          :additionalUserData="additionalUserData"
          :archiveUserData="archiveUserData"
          @addarchivefield="addarchivefield"
          @deletearchivefield="deletearchivefield"
        />
        <reportData
          v-else-if="visible_app[0] == 5"
          :userInfo="info"
          :companies="companies"
          :departments="departments"
          :currentUserIdForEdit="currentUserIdForEdit"
          @changecurrentUserIdForEdit="changecurrentUserIdForEdit"
          @loadSelectedReportData="loadSelectedReportData"
          @resize="resize"
          :isAdmin="isAdmin"
          :currentUserObj="currentUserObj"
          :userAccess="userAccess"
          :DniWRoku="DniWRoku"
        />
        <settingsData
          v-else-if="visible_app[0] == 6"
          :userInfo="info"
          :license_settings="license_settings"
          :status_license_main="status_license_main"
          :currentUserIdForEdit="currentUserIdForEdit"
          @changecurrentUserIdForEdit="changecurrentUserIdForEdit"
          :settingsUserData="settingsUserData"
          @setNewSettings="setNewSettings"
          @setNewSettingsCompany="setNewSettingsCompany"
          :isAdmin="isAdmin"
          :currentUserObj="currentUserObj"
          :userAccess="userAccess"
          :companyTypes="companyTypes"
        />
      </div>
    </a-spin>
  </div>
</template>

<script>
import moment from "moment";
import commonData from "./components/commonData.vue";
import closedData from "./components/closedData.vue";
import vacationData from "./components/vacationData.vue";
import additionalData from "./components/additionalData.vue";
import reportData from "./components/reportData.vue";
import settingsData from "./components/settingsData.vue";
import { updateAuth, generateFormData } from "./requestFunc";
export default {
  name: "App",
  components: {
    commonData,
    closedData,
    additionalData,
    vacationData,
    reportData,
    settingsData,
  },
  data: function () {
    return {
      status_license_main: "empty",
      daysLeft: "0",
      license_settings: {},
      visible_app: ["1"],
      adtlEmplInfDataSource: [],
      mainNavBarTabNames: [
        this.$t("Dane systemowe"),
        this.$t("Dane zamkniete"),
        this.$t("Urlopy"),
        this.$t("Historia"),
        this.$t("Raporty"),
        this.$t("Settings"),
      ],
      eventID: [],
      info: [],
      departments: [],
      companies: {},
      allcompanies: {},
      currentUserIdForEdit: "",
      isAdmin: false,
      closedUserData: {},
      entityUser: {},
      allHolidayDays: "",
      holidaysAllMass: [],
      UzywaneDni: 0,
      DniWRoku: "",
      DniNieobecnosci: 0,
      EwentualniePozostalo: 0,
      DataAktualizacji: "",
      spinning: true,
      currentUserObj: {},
      settingsUserData: {},
      userAccess: [],
      additionalUserData: [],
      archiveUserData: [],
      category_1: ["NAME", "LAST_NAME", "UF_DEPARTMENT", "WORK_POSITION"],
      category_2: ["EMAIL", "PERSONAL_MOBILE", "UF_PHONE_INNER"],
      category_3: [
        "SECOND_NAME",
        "NazwiskoRodowe",
        "PERSONAL_CITY",
        "PERSONAL_BIRTHDAY",
        "PERSONAL_GENDER",
        "PESEL",
        "NIP",
        "NrDoc",
        "Skarbowy",
        "Wyksztalcenie",
      ],
      category_4: [
        "StanZatrudnienia",
        "FormaRozwiazania",
        "TypZatrudnienia",
        "NazwaFirmy",
        "DataZatrudnienia",
        "DataZakonczeniaRozwiazania",
        "dataZvolnienia",
        "Wynagrodzenie",
        "Prowizja",
        "Premia",
        "additionalEmployeeInformation",
        "BadaniaLekarskie",
        "SzkolenieBHP",
        "WymiarUrlopu",
        "Ekwiwalent",
        "Student",
        "Samozatrudnienie",
      ],
      category_5: [
        "employeeGoalsInformation",
        "competenceEmployeeInformation",
        "trainingEmployeeInformation",
        "evaluationFormEmployeeInformation",
        "PlanRozwojuPracownika",
      ],
      localeApp: "",
      currentBxUserDepartments: [],
      infoo_currentUsersInDepartments: [],
      companyTypes: [],
      currentDefaultYear: "2022",
    };
  },
  methods: {
    moment,
    deletearchivefield(obj) {
      this.archiveUserData = obj;
    },
    addarchivefield(obj) {
      this.archiveUserData.unshift(obj);
    },
    changeSpinning(val) {
      if (val) this.spinning = val;
      else this.spinning = !this.spinning;
    },
    setNewSettings(val) {
      if (val) this.settingsUserData = val;
    },
    setNewSettingsCompany(val) {
      if (val) this.settingsUserData.companyTypes = JSON.parse(val);
    },
    deleteIndexEvent({ event, days }) {
      this.holidaysAllMass = this.holidaysAllMass.filter(
        (el, index) => index != event
      );
      this.eventID = this.eventID.filter((el, index) => index != event);
      this.UzywaneDni = days.useDays;
      this.DniNieobecnosci = days.timeOff;
      this.EwentualniePozostalo = days.waitingConfirmed;
    },

    changecurrentUserIdForEdit(event) {
      this.currentUserIdForEdit = event;
    },
    changeEventHoliday(event) {
      event.period.start = new Date(event.period.start);
      event.period.end = new Date(event.period.end);
      event.period.name = this.$t("Vacation");

      let indexChange = this.eventID.indexOf(event.id);
      this.holidaysAllMass = this.holidaysAllMass.map((el, index) => {
        if (index == indexChange) return event.period;
        else return el;
      });
      this.UzywaneDni = event.useDays;
      this.DniNieobecnosci = event.timeOff;
      this.EwentualniePozostalo = event.waitingConfirmed;
    },
    setAllHolidayDay(event) {
      this.holidaysAllMass.push(event);
    },
    setEventID(event) {
      this.eventID.push(event);
    },
    setNewUserBxInfo(field, value) {
      this.info[this.currentUserIdForEdit][field] = value;
    },
    setNewUserInfo(field, value) {
      this.entityUser[field] = value;
    },
    setNewClosedData(value) {
      this.closedUserData = value;
    },
    async changeTab(flag) {
      let user_id = this.info[this.currentUserIdForEdit].ID;
      if (flag == 2) {
        await this.loadClosedData(user_id);
        this.$refs.closedData.initData();
      } else if (flag == 3) {
        await this.loadHolidaysData({
          id: user_id,
          currentYearInCalendar: this.currentDefaultYear,
        });
      } else if (flag == 1) {
        await this.loadCommonUserData(user_id);
      } else if (flag == 4) {
        await this.loadAdditionalData(user_id);
      } else if (flag == 5) {
        await this.loadReportData(user_id);
      }
    },
    async loadSelectedClosedData(flag) {
      await this.changeTab(flag);
    },
    async loadSelectedCommonData(flag) {
      await this.changeTab(flag);
    },
    async loadSelectedHolideyData(flag) {
      await this.changeTab(flag);
    },
    async loadSelectedReportData(flag) {
      await this.changeTab(flag);
    },
    async loadSelectedAdditionalData(flag) {
      await this.changeTab(flag);
    },
    formCategory(field) {
      if (this.category_1.indexOf(field) != -1)
        return this.$t("Dane podstawowe");
      else if (this.category_2.indexOf(field) != -1)
        return this.$t("Dane kontaktowe");
      else if (this.category_3.indexOf(field) != -1)
        return this.$t("Dane personalne");
      else if (this.category_4.indexOf(field) != -1)
        return this.$t("Dane o zatrudnieniu");
      else if (this.category_5.indexOf(field) != -1)
        return this.$t("Rozwoj Pracownika");
      else return "";
    },
    formatData(el) {
      if (["[]", "Invalid date", " ", ""].indexOf(el.old) != -1) {
        el.old = "";
      }
      if (["[]", "Invalid date", " ", ""].indexOf(el.new) != -1) {
        el.new = "";
      }
      return el;
    },
    async loadAdditionalData(id) {
      let url = "/php/request.php";

      const response = await fetch(url, {
        method: "POST",
        body: generateFormData({
          token: updateAuth().token,
          domain: updateAuth().domain,
          run: "loadAdditionalData",
          user_id: id,
        }),
      });

      const results = await response.json();

      this.additionalUserData = results.data
        .map((el) => {
          {
            let user = this.info.find((user) => user.ID == el.creator);
            let user_fio = user ? user.LAST_NAME + " " + user.NAME : "";

            let history_item = {
              key: el.mainid,
              field: this.$t(el.type_change),
              category: this.formCategory(el.type_change),
              ...this.formatData(el),
              user: user_fio,
            };

            return history_item;
          }
        })
        .reverse();

      this.archiveUserData = results.dataArchive
        .map((el) => {
          {
            return {
              key: el.fileID,
              archivedate: el.backupDate,
              comment: el.comment,
            };
          }
        })
        .reverse();
    },

    async loadReportData(id) {
      let url = "/php/request.php";

      await fetch(url, {
        method: "POST",
        body: generateFormData({
          token: updateAuth().token,
          domain: updateAuth().domain,
          run: "loadReportData",
          user_id: id,
        }),
      });
    },
    async loadClosedData(id) {
      let url = "/php/request.php";

      const response = await fetch(url, {
        method: "POST",
        body: generateFormData({
          token: updateAuth().token,
          domain: updateAuth().domain,
          run: "loadClosedData",
          user_id: id,
        }),
      });

      const results = await response.json();

      let abc =
        results.info && results.info.WymiarUrlopu
          ? results.info.WymiarUrlopu
          : [];
      let dni = 0;
      abc.forEach((element) => {
        if (+element.date == +moment().format("YYYY")) {
          dni = element.name;
        }
      });
      this.DniWRoku = dni;

      this.UzywaneDni =
        results.info && results.info.useDays && results.info.useDays != ""
          ? results.info.useDays
          : "0";

      this.closedUserData = results.info;
      this.adtlEmplInfDataSource = results.option.additionalEmployeeInformation
        ? results.option.additionalEmployeeInformation
        : [];
      if (this.closedUserData) {
        for (let i of [
          "WymiarUrlopu",
          "additionalEmployeeInformation",
          "employeeGoalsInformation",
          "competenceEmployeeInformation",
          "evaluationFormEmployeeInformation",
          "trainingEmployeeInformation",
          "BadaniaLekarskie",
          "SzkolenieBHP",
        ]) {
          if (
            this.closedUserData[i] &&
            typeof this.closedUserData[i] == "string"
          ) {
            this.closedUserData[i] = JSON.parse(this.closedUserData[i]);
          }
        }
      }
    },
    async loadHolidaysData({ id, currentYearInCalendar }) {
      let url = "/php/request.php";

      if (currentYearInCalendar != this.currentDefaultYear)
        this.currentDefaultYear = currentYearInCalendar;

      const response = await fetch(url, {
        method: "POST",
        body: generateFormData({
          token: updateAuth().token,
          domain: updateAuth().domain,
          run: "loadHolidaysData",
          user_id: id,
          currentYearInCalendar,
        }),
      });

      const results = await response.json();
      console.log(results, "results");
      this.holidaysAllMass = results.calendar.map((el) => {
        if (el.calendarInfo.name == "Urlop") {
          el.calendarInfo.name = this.$t("Vacation");
        } else if (el.calendarInfo.name == "Wniosek o urlop") {
          el.calendarInfo.name = this.$t("Vacation application");
        } else if (el.calendarInfo.name == "Nieobecnosc") {
          el.calendarInfo.name = this.$t("Absence");
        }

        el.calendarInfo.start = new Date(el.calendarInfo.start);
        el.calendarInfo.end = new Date(el.calendarInfo.end);
        return el.calendarInfo;
      });
      this.eventID = results.calendar.map((el) => {
        return el.eventID;
      });
      // this.UzywaneDni=results.userEntity()

      this.DniWRoku = results.daysLeft;

      // this.UzywaneDni =
      //   results.userEntity && results.userEntity.useDays != ""
      //     ? results.userEntity.useDays
      //     : "0";

      this.UzywaneDni = results.useDays ? results.useDays : "0";

      this.DniNieobecnosci = results.timeOff || "0";
      // results.userEntity && results.userEntity.timeOff != ""
      //   ? results.userEntity.timeOff
      //   : "0";
      this.EwentualniePozostalo =
        results.userEntity && results.userEntity.waitingConfirmed != ""
          ? results.userEntity.waitingConfirmed
          : "0";
      // results.userEntity.waitingConfirmed;
      this.DataAktualizacji = "";
    },
    async onChangeHolidayMode(e) {
      if (e == "all") {
        let url = "/php/request.php";

        const response = await fetch(url, {
          method: "POST",
          body: generateFormData({
            token: updateAuth().token,
            domain: updateAuth().domain,
            run: "loadAllHolidaysData",
          }),
        });

        const results = await response.json();

        this.holidaysAllMass = results.calendar.map((el) => {
          el.calendarInfo.start = new Date(el.calendarInfo.start);
          el.calendarInfo.end = new Date(el.calendarInfo.end);
          el.calendarInfo.eventID = el.eventID;
          el.calendarInfo.userID = el.userID;

          let currU = this.info.filter((item) => {
            if (item.ID == el.userID) return item;
          });
          let currUser = currU.length != 0 ? currU[0] : "";

          el.calendarInfo.name = currUser.NAME + " " + currUser.LAST_NAME;
          return el.calendarInfo;
        });
      } else {
        console.log(this.currentUserIdForEdit, "user");
        await this.loadHolidaysData({
          id: this.currentUserIdForEdit,
          currentYearInCalendar: this.currentDefaultYear,
        });
      }
    },
    async loadCommonUserData(id) {
      let url = "/php/request.php";

      const response = await fetch(url, {
        method: "POST",
        body: generateFormData({
          token: updateAuth().token,
          domain: updateAuth().domain,
          run: "loadCommonUserData",
          user_id: id,
        }),
      });

      const results = await response.json();
      this.entityUser = results.userEntity ? results.userEntity : {};
      this.daysLeft = results.daysLeft;

      // this.DniWRoku = results.daysLeft;
      let abc = JSON.parse(
        results.userEntity && results.userEntity.WymiarUrlopu
          ? results.userEntity.WymiarUrlopu
          : "[]"
      );
      let dni = 0;
      abc.forEach((element) => {
        if (+element.date == +moment().format("YYYY")) {
          dni = element.name;
        }
      });
      this.DniWRoku = dni;

      // this.UzywaneDni =
      //   results.userEntity &&
      //   results.userEntity.useDays &&
      //   results.userEntity.useDays != ""
      //     ? results.userEntity.useDays
      //     : "0";

      this.UzywaneDni = results.useDays;
      this.DniNieobecnosci =
        results.userEntity && results.userEntity.timeOff != ""
          ? results.userEntity.timeOff
          : "0";
      this.EwentualniePozostalo =
        results.userEntity && results.userEntity.waitingConfirmed != ""
          ? results.userEntity.waitingConfirmed
          : "0";
    },
    resize() {
      BX24.resizeWindow(
        parseInt($("body #app").css("width")),
        parseInt($("body #app").css("height"))
      );
    },
    convertArrayToObject(array, key) {
      const initialValue = {};
      return array.reduce((obj, item) => {
        return {
          ...obj,
          [item[key]]: item,
        };
      }, initialValue);
    },
    async loadFilesAndSettings() {
      const response = await fetch("/php/request.php", {
        method: "POST",
        body: generateFormData({
          token: updateAuth().token,
          domain: updateAuth().domain,
          run: "loadFilesAndSettings",
        }),
      });

      const results = await response.json();
      console.log(results, "results");
      this.settingsUserData = results.settings;

      let status_license = {};
      if (results.license.lic_key == "") {
        if (moment().isBefore(moment(results.license.trial_end_date))) {
          status_license.condition = "trial";
        } else status_license.condition = "empty";
      } else {
        if (moment().isBefore(moment(results.license.lic_end_date))) {
          status_license.condition = "full";
        } else status_license.condition = "empty";
      }
      this.status_license_main = status_license;

      if (this.status_license_main.condition == "empty") {
        this.visible_app[0] = 6;
      }

      console.log(this.status_license_main, "status_license_main");

      this.license_settings = results.license;

      this.companyTypes = results.type;
      this.info = results.articles;
      this.currentUserObj = results.users;
      this.daysLeft = results.daysLeft;
      this.departments = results.department;
      this.companies = {} /*this.convertArrayToObject(results.company, "ID")*/;
      this.allcompanies =
        {} /*this.convertArrayToObject(results.allCompnay, "ID")*/;
      // this.entityUser = results.entityUser;
      this.entityUser = results.userEntity ? results.userEntity : {};

      let currentBxIdUser = results.users.ID;
      if (
        this.settingsUserData["HR"] !== undefined &&
        this.settingsUserData["HR"] !== null &&
        Array.isArray(this.settingsUserData["HR"])
      ) {
        if (this.settingsUserData["HR"].indexOf(currentBxIdUser) != -1) {
          this.userAccess.push("HR");
        }
      }
      if (
        this.settingsUserData["CEO"] !== undefined &&
        this.settingsUserData["CEO"] !== null &&
        Array.isArray(this.settingsUserData["CEO"])
      ) {
        if (this.settingsUserData["CEO"].indexOf(currentBxIdUser) != -1) {
          this.userAccess.push("CEO");
        }
      }
      if (
        this.settingsUserData["Office"] !== undefined &&
        this.settingsUserData["Office"] !== null &&
        Array.isArray(this.settingsUserData["Office"])
      ) {
        if (this.settingsUserData["Office"].indexOf(currentBxIdUser) != -1) {
          this.userAccess.push("Office");
        }
      }

      if (this.departments) {
        // Проверка на руководителя
        this.currentBxUserDepartments = this.departments
          .filter((item) => currentBxIdUser == item.UF_HEAD)
          .map((el) => el.ID);

        if (this.currentBxUserDepartments.length != 0) {
          this.userAccess.push("Chief");
        }

        this.infoo_currentUsersInDepartments = this.info
          .filter((item) => {
            var b = [];
            for (var i = 0; i < this.currentBxUserDepartments.length; ++i) {
              for (var j = 0; j < item.UF_DEPARTMENT.length; ++j) {
                if (this.currentBxUserDepartments[i] == item.UF_DEPARTMENT[j])
                  b.push(this.currentBxUserDepartments[i]);
              }
            }
            if (b.length != 0) return item;
          })
          .map((item) => item.UF_DEPARTMENT);
      }

      this.currentUserIdForEdit = this.info.findIndex(
        (el) => el.ID == results.users.ID
      );
    },
  },
  created() {
    let vm = this;
    let lang = BX24.getLang();

    if (
      lang == "br" ||
      lang == "tr" ||
      lang == "ja" ||
      lang == "ms" ||
      lang == "fr" ||
      lang == "sc" ||
      lang == "vn" ||
      lang == "th" ||
      lang == "it" ||
      lang == "ua" ||
      lang == "tc" ||
      lang == "id" ||
      lang == "hi"
    ) {
      lang = "en";
    }
    vm.$i18n.locale = lang;
    this.localeApp = lang;
    /* vm.$i18n.locale = BX24.getLang();
    this.localeApp = BX24.getLang();*/
  },
  async mounted() {
    this.changeSpinning(true);
    await this.loadFilesAndSettings();
    await this.changeTab(1);
    this.changeSpinning(false);
    this.isAdmin = BX24.isAdmin();
    BX24.fitWindow();
  },
  updated() {
    // this.resize();
  },
};
</script>

<style scoped>
#app {
  font-family: Rubik, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app
  .ant-table-middle
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-tbody
  > tr
  > td,
#app
  .ant-table-middle
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table
  > .ant-table-tbody
  > tr
  > td,
#app
  .ant-table-middle
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body
  > table
  > .ant-table-thead
  > tr
  > th,
#app
  .ant-table-middle
  > .ant-table-content
  > .ant-table-fixed-right
  > .ant-table-body-outer
  > .ant-table-body-inner
  > table
  > .ant-table-thead
  > tr
  > th {
  padding: 0px 8px !important;
}

#maindivmenu {
  font-weight: 400;
}
</style>
